var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMic({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "WHITE",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: 0,
      height: 24
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.8421 15.1579C10.9389 15.1579 12.6316 13.4653 12.6316 11.3684V3.78947C12.6316 1.69263 10.9389 0 8.8421 0C6.74526 0 5.05263 1.69263 5.05263 3.78947V11.3684C5.05263 13.4653 6.74526 15.1579 8.8421 15.1579Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1579 11.3684C15.1579 14.8547 12.3284 17.6842 8.8421 17.6842C5.35579 17.6842 2.52632 14.8547 2.52632 11.3684H0C0 15.8273 3.29684 19.4905 7.57895 20.1094V24H10.1053V20.1094C14.3874 19.4905 17.6842 15.8273 17.6842 11.3684H15.1579Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.36eb88ab.svg";
export { ForwardRef as ReactComponent };